import React from "react"
import {
  BarChart, Bar, XAxis, YAxis, Tooltip, ResponsiveContainer, CartesianGrid, Legend,
} from "recharts"
import { CHART_COLORS } from "../constants"

export default function AbsorptionChart({ byProject = [] }) {
  if (!byProject.length) return null

  const data = byProject.map((p) => ({
    name: p.project.name,
    available: p.available,
    blocked: p.blocked,
    booked: p.booked,
    sold: p.sold,
  }))

  return (
    <div className="rounded-lg border border-slate-200 bg-white p-4">
      <div className="mb-3 text-[13px] font-medium text-slate-700">
        Inventory by Project
      </div>
      <ResponsiveContainer width="100%" height={Math.max(data.length * 56, 220)}>
        <BarChart data={data} layout="vertical" barCategoryGap="20%">
          <CartesianGrid strokeDasharray="3 3" stroke="#eef2f6" horizontal={false} />
          <XAxis type="number" tick={{ fontSize: 12 }} />
          <YAxis dataKey="name" type="category" tick={{ fontSize: 12 }} width={120} />
          <Tooltip />
          <Legend />
          <Bar dataKey="sold" stackId="a" fill={CHART_COLORS.sold} name="Sold" />
          <Bar dataKey="booked" stackId="a" fill={CHART_COLORS.booked} name="Booked" />
          <Bar dataKey="blocked" stackId="a" fill={CHART_COLORS.blocked} name="Blocked" />
          <Bar dataKey="available" stackId="a" fill={CHART_COLORS.available} name="Available" radius={[0, 4, 4, 0]} />
        </BarChart>
      </ResponsiveContainer>
    </div>
  )
}
